function IntroMenuitek() {
    return (
        <div id='menuitek' className="flex flex-col gap-4 lg:gap-8 xl:gap-12 px-[5vw] xl:px-[8vw]">
            <h1 className='font-semibold uppercase'>MENUITEK - L'EXCELLENCE DE LA MENUISERIE ACCESSIBLE à TOUS</h1>
            <div className="flex flex-col gap-4 lg:gap-8 xl:gap-12 border-b border-brun-contrast/50 pb-[5vh] text-justify text-brun-contrast">
                <p>Chez MENUITEK, nous sommes spécialisés dans la fourniture et la pose de fenêtres, portes et volets sur mesure, en aluminium, PVC et bois.
                    <br/>Notre mission est simple : améliorer durablement le confort, la sécurité et l’esthétique de vos espaces, tout en vous garantissant une qualité irréprochable.</p>
                <p>Que vous soyez particulier, architecte, promoteur ou entreprise, nous mettons à votre service notre exigence artisanale, notre sérieux professionnel et une expertise construite au fil des années sur le terrain en France.</p>
            </div>
        </div>
    )
}

export default IntroMenuitek;